import { useRef, useState } from "react";

const LOADING = { status: "loading", data: null };
const FAILED = { status: "error", data: null };

export const useLoad = (fetcher) => {
  const [load, setLoad] = useState(LOADING);
  const latestRequest = useRef(0);

  const start = (params) => {
    latestRequest.current += 1;
    const thisRequest = latestRequest.current;
    setLoad(LOADING);
    const settle = (settled) => {
      if (latestRequest.current === thisRequest) setLoad(settled);
    };
    fetcher(params).then(
      (data) => settle({ status: "ready", data }),
      () => settle(FAILED)
    );
  };

  const update = (change) => {
    setLoad((current) => (current.status === "ready" ? { ...current, data: change(current.data) } : current));
  };

  return [load, start, update];
};
